import React, { Component } from "react";
import { connect } from "react-redux";
import "./index.scss";
class Story extends Component {
  render() {
    const { props } = this;
    return (
      <div className="page_box wht" style={{ overflow: "hidden" }}>
        <div className="story_bg b_box"></div>
        <div className="story_content boxb">
          <div className="story_name">黄先生</div>
          <div className="story_txt">
            名校毕业，工作努力，表现优异。
            <br />
            最近刚刚升职，约同事去酒吧庆祝。
          </div>
          <div className="to_play dis_f ali_ct" onClick={props.nextFn}>
            <span>{props.nextTxt}</span>
            <img
              src={require("@img/history_play.png")}
              className="play_icon"
              alt=""
            />
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = state => {
  return state;
};
export default connect(mapStateToProps, null)(Story);
